<template lang="pug" src="./templates/Login.pug"></template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import FacebookLoginButton from '../buttons/auth/FacebookLoginButton.vue';
import notify from '../notify';
import router from '../../routes';

export default {
  components: {
    FacebookLoginButton,
  },
  mixins: [validationMixin],
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    async authenticate() {
      this.$wait.start('logging in');
      notify.loading(this, { title: Lang.get('alerts.general.please_wait'), text: false });
      try {
        await this.$store.dispatch('auth/login', { email: this.email, password: this.password });
        notify.clean(this).then(() => notify.success(this, { title: Lang.get('alerts.frontend.general.logged_in'), text: false }));
        await this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'], fetch: true });
      } catch (e) {
        if (typeof e.response.data.code !== 'undefined' && e.response.data.code === 'migrated_user') {
          router.push({ name: 'reset-password' });
        }
        notify.clean(this).then(() => notify.errors(this, e));
      }
      this.$wait.end('logging in');
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>
